module.exports = "/_next/static/images/hybrid-fdc2edc305c46df83a1e08ea34354821.jpg";